const LocalTimeHook = {
  mounted() {
    this.updateTime();
  },

  updateTime() {
    const utcTime = this.el.dataset.utcTime;
    
    if (utcTime && utcTime !== "Never") {
      try {
        const localTime = new Date(utcTime);
        const timeString = localTime.toLocaleTimeString([], { 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit',
          timeZoneName: 'short'
        });
        this.el.textContent = timeString;
      } catch (error) {
        console.error('Error converting time:', error);
        this.el.textContent = 'Error';
      }
    } else {
      this.el.textContent = 'Never';
    }
  },

  // Handle LiveView updates
  beforeUpdate() {
    // Store the current time to compare
    this.currentTime = this.el.textContent;
  },

  updated() {
    // Check if the data attribute changed
    const newUtcTime = this.el.dataset.utcTime;
    if (newUtcTime !== this.lastUtcTime) {
      this.lastUtcTime = newUtcTime;
      this.updateTime();
    }
  }
};

export default LocalTimeHook;
